import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import UserFormComponent from "./UserFormComponent";

const UserForm = () => {
  document.title = "Formulário de usuários";

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Formulário de usuários" pageTitle="Usuários" />
        </Container>
        <UserFormComponent />
      </div>
    </React.Fragment>
  );
};

export default UserForm;
